import i18n from 'i18next';
import { useMemo, useEffect } from 'react';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import ReactGA from 'react-ga';
import classNames from 'classnames';
import { socialLinks } from '../../../../config/FooterLinksConfig';
import SocialLinks from './SocialLinks/SocialLinks';
import FooterLinks from './FooterLinks/FooterLinks';
import AppPaths from '../../../../routes/AppPaths';
import * as actions from '../../../../store/actions';
import './Footer.scss';

import { isRTL } from '../../../../constants';
import Newsletter from '../../routes/Home/components/Newsletter/Newsletter';

const Footer = (props) => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(actions.getFooterFaqs(1));
  }, [dispatch]);

  const isAuth = props;

  const { footer, footerFaqs } = useSelector((state) => state.menu);
  const contentPage = footer.filter(
    (_) => _.linkType === 'page' && _.contentPage?.slug !== 'about-us1-2'
  );

  const { siteSettings } = useSelector((state) => state.siteSettings);
  const { meta } = useSelector((state) => state.meta);

  useMemo(() => {
    if (siteSettings?.googleAnalyticsCode) {
      ReactGA.initialize(siteSettings?.googleAnalyticsCode);
      ReactGA.pageview(window.location.pathname + window.location.search);
    }
  }, [siteSettings?.googleAnalyticsCode]);

  /**
   * Adds an event listener for the visibilitychange event when the component mounts.
   * When the page becomes visible again, it calls showNotification to request notification permission.
   * Removes the event listener when the component unmounts.
   */
  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        showNotification();
      }
    };

    const showNotification = () => {
      if ('Notification' in window) {
        Notification.requestPermission().then((permission) => {
          if (permission === 'granted') {
          }
        });
      }
    };
    document.addEventListener('visibilitychange', handleVisibilityChange);
    // Clean up the event listener on component unmount
    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, []);

  return (
    <footer
      className="footer-wrapper"
      id="mainSiteFooter"
    >
      <Container>
        <Row className="justify-content-between flex-column-reverse flex-md-row">
          <Col
            md={5}
            className="mb-4 mb-md-0 newsletter-wrapper"
          >
            <Newsletter />
            <Card.Body className=" d-flex justify-content-center d-md-none">
              <SocialLinks heading={socialLinks.heading} />
            </Card.Body>
            <Card.Body className="footer-copyright">
              &copy;{new Date().getFullYear()} {meta?.siteName}
              {i18n.t('footerLink.footerCopyright')}
            </Card.Body>
          </Col>

          <Col
            md={6}
            className={classNames(
              'd-none d-md-block',
              isRTL ? 'text-md-start' : 'text-md-end'
            )}
          >
            <nav className="mb-4 footer-nav flex-column flex-md-row flex flex-wrap">
              {footerFaqs?.docs?.length > 0 ? (
                <Link
                  to={AppPaths.FAQ_PATH}
                  className={classNames('footer-link', isRTL ? 'me-3' : 'ms-3')}
                >
                  {i18n.t('footerLink.faqs')}
                </Link>
              ) : null}
              <Link
                to={AppPaths.CONTACT_US_PATH}
                className={classNames('footer-link', isRTL ? 'me-3' : 'ms-3')}
              >
                {i18n.t('footerLink.contactUs')}
              </Link>
              <FooterLinks
                linkItem={contentPage}
                columnNum={'auto'}
              />
            </nav>
            <div className="w-100">
              {!isAuth && (
                <>
                  <Button
                    variant="outline-light"
                    className={classNames(
                      'square-btn',
                      isRTL ? 'ms-2' : 'me-2'
                    )}
                  >
                    <Link
                      id="headerLogin"
                      className="nav-link "
                      to={AppPaths.LOGIN_PATH}
                      data-test="component-header-login"
                    >
                      {i18n.t('menu.signIn')}
                    </Link>
                  </Button>
                  <Button
                    variant="success square-btn"
                    className={classNames('square-btn my-2')}
                  >
                    <Link
                      id="headerSignup"
                      className="nav-link"
                      to={AppPaths.SIGNUP_PATH}
                    >
                      {i18n.t('menu.signUp')}
                    </Link>
                  </Button>
                </>
              )}
              <SocialLinks heading={socialLinks.heading} />
            </div>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;
